import React from 'react';
import { connect, useDispatch } from 'react-redux';

import { Button } from '~/eds/src/components/Button/Button';
import { ManageSyncPairStageType } from '~/enums/ManageSyncPairStageType';
import { OnboardingIdType } from '~/features/onboarding/OnboardingIdType';
import { useIntl } from 'react-intl';
import { slices } from '~/redux/slices';
import FlexLayout from '~/ui/components/FlexLayout/FlexLayout';
import Text from '~/ui/components/Text/Text';

function EmptySyncPairsPlaceholder() {
  const intl = useIntl();
  const dispatch = useDispatch();

  return (
    <FlexLayout
      alignItems="center"
      flexDirection="column"
      justifyContent="center"
      p={16}
      space={6}
      sx={{
        border: 'border',
        borderRadius: 'm',
      }}
    >
      <Text color="gray-600" variant="s-spaced">
        {intl.formatMessage({
          id: 'EmptySyncPairsPlaceholder.noSyncPairsYet',
          defaultMessage: 'No sync pairs yet',
          description:
            'Message displayed when there are no sync pairs configured',
        })}
      </Text>
      <Button
        id={OnboardingIdType.AddSyncPairButton}
        text={intl.formatMessage({
          id: 'EmptySyncPairsPlaceholder.addSyncPairButton',
          defaultMessage: 'Add Sync Pair',
          description: 'Button text to add a new sync pair',
        })}
        onClick={() =>
          dispatch(
            slices.integrations.actions.setManageSyncPairStage(
              ManageSyncPairStageType.Provider,
            ),
          )
        }
        variant="primary"
      />
    </FlexLayout>
  );
}

export default connect(null)(EmptySyncPairsPlaceholder);
